// import React, { ReactNode } from "react";
// import { queryClient } from "../../core";
// import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { store } from "../../store";
// import { Provider } from "react-redux";
// interface AppproviderProps {
//   children: ReactNode;
// }
// const AppProvider: React.FC<AppproviderProps> = ({ children }) => {
//   return (
//     <Provider store={store}>
//       <QueryClientProvider client={queryClient}>
//         {children}
//         <ReactQueryDevtools initialIsOpen={false} />
//       </QueryClientProvider>
//     </Provider>
//   );
// };

// export default AppProvider;

// src/providers/AppProviders.tsx
// ═══════════════════════════════════════════════════════════════════════════════
// COMBINED APP PROVIDERS
// ═══════════════════════════════════════════════════════════════════════════════

import React, { useCallback } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryProvider } from "./QueryProvider";
import { ToastProvider } from "./ToastProvider";
import { ErrorBoundaryProvider } from "./ErrorBoundaryProvider";
import { AuthenticationError } from "@/core/errors/classes";
import { toast } from "react-toastify";
import { store } from "@/store";
import { Provider } from "react-redux";
import { router } from "@/routes"; // Import router instance
import { logger } from "@/core";

export const AppProviders: React.FC = () => {
  const handleAuthError = useCallback((error: AuthenticationError) => {
    // Clear auth state
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");

    // Show toast
    toast.error("Your session has expired. Please log in again.", {
      // icon: "🔐",
      toastId: "auth-error",
    });
    logger.error(error.cause as string);
    // Use router.navigate directly (no hook needed!)
    router.navigate("/login", {
      replace: true,
      state: { from: window.location.pathname },
    });
  }, []);

  return (
    <ErrorBoundaryProvider scope="App">
      <Provider store={store}>
        <QueryProvider onAuthError={handleAuthError}>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </QueryProvider>
      </Provider>
    </ErrorBoundaryProvider>
  );
};
